import styled from 'styled-components';

export const Container = styled.div`
  color: #fb6054;
  font-size: 0.9rem;
  margin-top: 4px;
`;
